import {
  createStore,
  compose,
  applyMiddleware,
  combineReducers,
} from 'redux';
import thunk from 'redux-thunk';

// import reducers
import cart from './cart/reducer';
import cartUpsell from './cartUpsell/reducer';
import recentItems from './recentItems/reducer';

const reducers = combineReducers({
  cart,
  cartUpsell,
  recentItems,
});

/* eslint-disable no-underscore-dangle */
const composeEnhancers = typeof window === 'object'
    && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
  }) : compose;
/* eslint-enable */

const middleware = composeEnhancers(applyMiddleware(thunk));

export default createStore(reducers, middleware);
